<template>
  <div ref="layout" class="page-query">
    <TableQuery title="价格主数据批导" :tools="false">
      <el-form inline class="form" size="mini">
        <el-row>
          <el-col :span="8">
            <el-form-item label="批导类型">
              <el-select
                v-model="type"
                placeholder="请选择"
                type="select"
                clearable
                @change="changeTempType"
              >
                <el-option v-for="item in types" :key="item.value" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16" class="download">
            <div v-if="$_has(['WLY023', 'WLY024'])" class="el-dropdown">
              <div class="tempDownload" @click="downloadTemplate({type: 'priceDataYxdyImport',fileName: '价格主数据-中心价格模板_V1.0'})">
                <img src="@/assets/images/excel@3x.png" alt="">
                <span class="el-dropdown-link">
                  模版下载
                </span>
              </div>
            </div>
            <el-dropdown v-else @command="downloadTemplate">
              <div class="tempDownload">
                <img src="@/assets/images/excel@3x.png" alt="">
                <span class="el-dropdown-link">
                  模版下载
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{
                    type: 'priceDataCustImport',
                    fileName: '价格主数据-客户价格模板_V1.0'
                  }"
                >客户价格模板导出</el-dropdown-item>
                <el-dropdown-item
                  :command="{
                    type: 'priceDataYxdyImport',
                    fileName: '价格主数据-中心价格模板_V1.0'
                  }"
                >中心价格模板导出</el-dropdown-item>
                <el-dropdown-item
                  :command="{
                    type: 'priceDataCompanyImport',
                    fileName: '价格主数据-出厂价格模板_V1.0'
                  }"
                >出厂价格模板导出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <div class="table-container">
      <TableCommon
        title="批导数据"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <template #button>
          <table-button name="import" tip="价格批导" @click="handleImportExcel" />
          <table-button name="save" tip="价格保存" @click="saveData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { apiExportExcelTemplate, apiExcelImport, apiGetExcelImportData } from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { apiPriceImport } from '@/api/sap/client-sap'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      conditions: {
        templateCode: 'priceDataCustImport',
        batchNumber: ''
      },
      type: 'CUS80100',
      types: [],
      temp: {
        CUS80100: 'priceDataCustImport',
        CUS80200: 'priceDataYxdyImport',
        CUS80300: 'priceDataCompanyImport'
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { field: 'ICON', title: '状态', width: 180 },
          { field: 'PRODUCT_ID', title: '产品 ID', width: 180 },
          { field: 'ZPRIC_TYPE', title: '价格类型', width: 180 },
          { field: 'ZSALESUNIT', title: '营销单元', width: 180 },
          { field: 'SOLD_TO_PARTY', title: '客户编号', width: 180 },
          { field: 'KONWA', title: '价格单位', width: 180 },
          { field: 'KMEIN', title: '销售单位', width: 180 },
          { field: 'TIMESTAMP_FROM', title: '有效期从', width: 180 },
          { field: 'TIMESTAMP_TO', title: '有效期止', width: 180 },
          { field: 'KBETR', title: '价格', width: 180 },
          { field: 'O_KBETR', title: '老价格', width: 180 },
          { field: 'O_FROM', title: '老价格失效日期', width: 180 },
          { field: 'CREATE_DATE', title: '创建日期', width: 180 },
          { field: 'REMARK', title: '备注', width: 180 },
          { field: 'UNAME', title: '批导人', width: 180 },
          { field: 'DATUM', title: '批导日期', width: 180 }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    if (this.$_has(['WLY023', 'WLY024'])) {
      this.type = 'CUS80200'
      this.types.push({
        name: '中心价格',
        value: 'CUS80200'
      })
    } else {
      this.types = [
        { name: '客户价', value: 'CUS80100' },
        { name: '中心价', value: 'CUS80200' },
        { name: '出厂价', value: 'CUS80300' }
      ]
    }
  },
  methods: {
    // 模板下崽
    async downloadTemplate({ type, fileName }) {
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      // link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    changeTempType(e) {
      this.conditions.templateCode = this.temp[e]
      this.gridOptions.data = []
    },
    // 处理分页事件
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.handleQueryImportExcel()
    },
    // 导入excel
    async handleImportExcel() {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.conditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const params = { ...this.conditions, page: 1, pagesize: 1000 }
      const { data } = await apiGetExcelImportData(params)
      for (const item of data.Rows) {
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          delete item[key]
        })
      }
      // 数据检查，然后再保存
      this.checkData(data.Rows, 'X')
    },
    async checkData(data, check = '') {
      const type = {
        CUS80100: 'HEAD_801',
        CUS80200: 'HEAD_802',
        CUS80300: 'HEAD_803'
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        check,
        price_type: this.type,
        [type[this.type]]: data || this.gridOptions.data
      }
      const res = await apiPriceImport(params)
      if (res.MSGTYPE === 'S') {
        this.gridOptions.data = res.DATA
        if (!check) {
          return this.$message.success(res.MESSAGE)
        }
      } else {
        this.$message.warning(res.MESSAGE)
      }
    },
    async saveData() {
      this.checkData()
    },
    // 驼峰转成下划线并且大写
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.download {
  text-align: right;
  line-height: 36px;
  font-size: 14px;
  .tempDownload {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
    span {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/price-manage/priceBatchImp.vue